import { push } from 'connected-react-router'

import { getUrlParams } from '../../utils'
import { ROUTES } from 'routes/paths'

/*
 * action types
 */

const tag = '@@drawer/'

export const DECREMENT_LOADER = `${tag}DECREMENT_LOADER`
export const DISABLE_LOADER = `${tag}DISABLE_LOADER`
export const INCREMENT_LOADER = `${tag}INCREMENT_LOADER`
export const REMOVE_FEEDBACK_ALERT = `${tag}REMOVE_FEEDBACK_ALERT`
export const REQUEST = `${tag}REQUEST`
export const RESET = `${tag}RESET`
export const RESET_ERROR = `${tag}RESET_ERROR`
export const RESET_LOADER = `${tag}RESET_LOADER`
export const SET_SHOW_HEADER = `${tag}SET_SHOW_HEADER`
export const SET_SCROLLABLE = `${tag}SET_SCROLLABLE`
export const UPDATE_ERROR = `${tag}UPDATE_ERROR`
export const UPDATE_FEEDBACK_ALERT = `${tag}UPDATE_FEEDBACK_ALERT`
export const UPDATE_FULL_GRID = `${tag}UPDATE_FULL_GRID`
export const UPDATE_FULL_SCREEN = `${tag}UPDATE_FULL_SCREEN`
export const UPDATE_HEADER_TYPE = `${tag}UPDATE_HEADER_TYPE`
export const UPDATE_MODAL_TYPE = `${tag} UPDATE_MODAL_TYPE`
export const SET_FOOTER = `${tag}SET_FOOTER`
export const SET_FOOTER_ENABLED = `${tag}SET_FOOTER_ENABLED`

/*
 * action creators
 */

export const decrementLoader = () => ({ type: DECREMENT_LOADER })

export const hideLoader = (payload) => ({ payload, type: DISABLE_LOADER })

export const incrementLoader = () => ({ type: INCREMENT_LOADER })

export const reset = (payload) => ({ payload, type: RESET })

export const resetLoader = () => ({ type: RESET_LOADER })

export const setHeader = (payload) => ({ payload, type: UPDATE_HEADER_TYPE })

export const setModal = (payload) => ({ payload, type: UPDATE_MODAL_TYPE })

export const setScrollable = (payload) => ({ payload, type: SET_SCROLLABLE })

export const updateError = (payload) => ({ payload, type: UPDATE_ERROR })

export const removeFeedbackAlert = (payload) => ({
  payload,
  type: REMOVE_FEEDBACK_ALERT,
})

export const updateFullScreen = (payload) => ({
  payload,
  type: UPDATE_FULL_SCREEN,
})

export const updateFullGrid = (payload) => ({
  payload,
  type: UPDATE_FULL_GRID,
})

export const resetError = () => ({ type: RESET_ERROR })

export const handleError =
  ({ loggedIn, goToLogin, status }) =>
  async (dispatch, getState) => {
    const {
      user,
      drawer: { errorData },
    } = getState()
    const urlLanguage = getUrlParams('lang')
    const language = user.locale || urlLanguage
    const sessionErrorUrl = language
      ? `${ROUTES.SESSION_ERROR}?lang=${language}`
      : `${ROUTES.SESSION_ERROR}`

    const errorStatus = new Set(
      [...errorData].map((error) => error?.response?.status)
    )
    if (!errorStatus.has(423) && (status === 401 || loggedIn === false)) {
      if (process.env.NODE_ENV !== 'development') {
        goToLogin()
      }
    }
    if (
      (status === 423 || errorStatus.has(423)) &&
      window.location.pathname !== sessionErrorUrl
    ) {
      dispatch(push(sessionErrorUrl))
    }
  }

export const setFooter = ({ children }) => ({
  payload: children,
  type: SET_FOOTER,
})

export const setFooterEnabled = (payload) => ({
  payload,
  type: SET_FOOTER_ENABLED,
})
